import { render } from "./WCImage.vue?vue&type=template&id=0ebe2489&scoped=true"
import script from "./WCImage.vue?vue&type=script&lang=js"
export * from "./WCImage.vue?vue&type=script&lang=js"

import "./WCImage.vue?vue&type=style&index=0&id=0ebe2489&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebe2489"]])

export default __exports__